import moment from 'moment';

export default function (state, action) {
    if (!state) {
        state = {
            loaded: false,
            listed: [],
            indexed: {},
        };
    }

    switch (action.type) {
        case 'UPDATE_EVENT_LOCATIONS':
            state = Object.assign({}, state, {
                fetchTime: moment(action.fetchTime),
                loaded: true,
                listed: action.locations,
                indexed: _(action.locations).reduce((indexed, location) => {
                    indexed[location.id] = location;
                    return indexed;
                }, {}),
            });
            break;
    }

    return state;
}
